


























































































































import { Component, Prop, Vue } from "vue-property-decorator";
import moment from "moment";
import AuditKuantitatifRmeService, {
  LaporanBangsal,
  LaporanBangsalBaris,
  Periode
} from "@/services/AuditKuantitatifRmeService";

@Component
export default class AuditKuantitatifRmeLaporanBangsal extends Vue {
  @Prop({ type: Number, default: null }) readonly bulanAwal!: number | null;
  @Prop({ type: Number, default: null }) readonly tahunAwal!: number | null;

  bulan: number = this.bulanAwal || moment().month() + 1;
  tahun: number = this.tahunAwal || moment().year();
  lap: LaporanBangsal | null = null;
  loading = false;
  unduhExcel = false;
  unduhPdf = false;

  bulanOptions = Array.from({ length: 12 }, (_, i) => ({
    value: i + 1,
    text: moment().month(i).format("MMMM")
  }));

  mounted() {
    this.muat();
  }

  get periodeValid(): boolean {
    return !!this.bulan && !!this.tahun && this.tahun >= 2000 && this.tahun <= 2100;
  }

  get periode(): Periode {
    return { tahun: Number(this.tahun), bulan: Number(this.bulan) };
  }

  async muat() {
    if (!this.periodeValid) return;
    this.loading = true;
    try {
      this.lap = await AuditKuantitatifRmeService.getLaporanBangsal(this.periode);
    } finally {
      this.loading = false;
    }
  }

  async excel() {
    this.unduhExcel = true;
    try {
      await AuditKuantitatifRmeService.downloadLaporanBangsalExcel(this.periode);
    } finally {
      this.unduhExcel = false;
    }
  }

  async pdf() {
    this.unduhPdf = true;
    try {
      await AuditKuantitatifRmeService.openLaporanBangsalPdf(this.periode);
    } finally {
      this.unduhPdf = false;
    }
  }

  sel(row: LaporanBangsalBaris, nilai: number | null): string | number {
    return row.jumlah > 0 && nilai !== null ? nilai : "";
  }

  angka(nilai: number | null): string | number {
    return nilai === null ? "" : nilai;
  }

  persen(nilai: number | null): string {
    return nilai === null ? "" : nilai.toLocaleString("id-ID", { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  }
}
